<template>
    <div>
        <!-- Label with Required Indicator -->
        <label :for="field.id" class="block text-sm font-medium text-gray-700 mb-2">
            {{ field.label }}
            <span v-if="field.required" class="text-red-500">*</span>
        </label>

        <!-- File Input with View Uploaded Button -->
        <div class="flex items-center space-x-4">
            <!-- File Input -->
            <div class="flex-grow">
                <input type="file" :id="field.id" @change="onFileChange"
                    class="block w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700 focus:ring-blue-500 focus:border-blue-500" />
            </div>

            <!-- View Uploaded File Button -->
            <div v-if="existingFileUrl" class="shrink-0">
                <a :href="existingFileUrl" target="_blank"
                    class="inline-block px-4 py-3 text-sm font-medium text-blue-600 bg-blue-100 border rounded-lg hover:bg-blue-200 transition-colors duration-200 whitespace-nowrap">
                    {{ $translate('View Uploaded File') }}
                </a>
            </div>
        </div>

        <!-- Field Description -->
        <p v-if="field.description" class="text-xs text-gray-500 mt-1">
            {{ field.description }}
        </p>

    </div>
</template>


<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: [File, String], // Can be either File or String (URL)
            default: '',
        },
        errorMessage: {
            type: String,
            default: '',
        }
    },
    computed: {
        existingFileUrl() {
            return typeof this.modelValue === 'string' ? this.modelValue : null;
        }
    },
    methods: {
        onFileChange(event) {
            const file = event.target.files[0];
            this.$emit('update:modelValue', file); // Emit the new file object
        }
    }
};
</script>
